import { render, staticRenderFns } from "./SmsTransaction.vue?vue&type=template&id=b6fd63dc&"
import script from "./SmsTransaction.vue?vue&type=script&lang=js&"
export * from "./SmsTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SmsTransaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports